class ComparisonTable extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['scroll-anchor']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setScrollAnchorWidth()
  }

  setupListeners () {
    super.setupListeners()

    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
    )

    this.observer.observe(this.els['scroll-anchor'].element)
  }

  /** @type {IntersectionObserverCallback} */
  handleIntersection ([entry]) {
    this.setAttribute('safe', entry.isIntersecting)
  }

  setScrollAnchorWidth () {
    if (!this.els['row-header']) {
      return
    }

    const rowHeaderWidth =
      this.els['row-header'].element.getBoundingClientRect().width
    this.style.setProperty(
      '--ScrollAnchor_Width',
      `${Math.round(rowHeaderWidth)}px`,
    )
  }
}

if (!window.customElements.get('comparison-table')) {
  window.customElements.define('comparison-table', ComparisonTable)
}
